import { Card } from '../components/Card';

export function Privacy() {
  return (
    <div className="mx-auto max-w-3xl">
      <h1 className="mb-8 text-2xl font-bold text-white">Privacy Policy</h1>
      <Card>
        <div className="prose-legal space-y-6 text-sm leading-relaxed text-iron-300">
          <p className="text-xs text-iron-500">Effective 14 April 2026 &middot; Updated 1 August 2026 &middot; Version 1.1</p>

          <section>
            <h2>1. Who We Are</h2>
            <p>GG Anvil is a competitive gaming tournament management platform operated by Good Game Anvil.</p>
            <p><strong className="text-white">Information Officer:</strong> Luke &middot; <strong className="text-white">Contact:</strong> privacy@goodgameanvil.com</p>
          </section>

          <section>
            <h2>2. What We Collect</h2>
            <p><strong className="text-white">From Discord:</strong> User ID, display name, avatar, account flags</p>
            <p><strong className="text-white">You provide:</strong> Gamertag, contact form messages, billing email (org admins)</p>
            <p><strong className="text-white">Generated:</strong> Match screenshots, AI-extracted scores, activity logs, match history, stats, memberships</p>
          </section>

          <section>
            <h2>3. Why We Process It</h2>
            <p>Authentication (consent), running tournaments (legitimate interest), score verification (legitimate interest), payments (contract), notifications (legitimate interest), audit logs (legitimate interest).</p>
          </section>

          <section>
            <h2>4. Who Sees It</h2>
            <p>Founders see all data. Org/comp admins see scoped data. Clan leaders see their roster. Other players see your gamertag, results, and standings. We never sell your data.</p>
          </section>

          <section>
            <h2>5. Third Parties</h2>
            <p>Discord (auth), cloud hosting (EU), AI vision services (score extraction), Stripe (international payments), Paystack (SA payments).</p>
          </section>

          <section>
            <h2>6. Cross-Border Transfers</h2>
            <p>Data is stored in the EU (Stockholm). The EU provides adequate protection under POPIA Section 72. Some processing occurs in the USA (Discord, AWS Bedrock, Stripe).</p>
          </section>

          <section>
            <h2>7. Retention</h2>
            <p>Profiles: until deletion requested. Screenshots: 365 days. Match results: 2 years. Activity logs: 1 year. Billing: 5 years. Contact forms: 6 months. Consent records: indefinite.</p>
          </section>

          <section>
            <h2>8. Your Rights (POPIA)</h2>
            <p><strong className="text-white">Access:</strong> Use Data Export below or email us. <strong className="text-white">Correction:</strong> Email us. <strong className="text-white">Deletion:</strong> Use Request Deletion below or email us. <strong className="text-white">Objection:</strong> Email us. <strong className="text-white">Portability:</strong> Data Export provides JSON format.</p>
            <p>We respond within 30 days. Email: privacy@goodgameanvil.com</p>
          </section>

          <section>
            <h2>9. Security</h2>
            <p>HTTPS/TLS encryption, AWS encryption at rest, role-based access, short-lived tokens, audit logging.</p>
          </section>

          <section>
            <h2>10. Cookies</h2>
            <p>No tracking cookies. JWT via URL param for auth, localStorage for UI preferences only. No third-party tracking.</p>
          </section>

          <section>
            <h2>11. Complaints</h2>
            <p>Contact privacy@goodgameanvil.com or the Information Regulator of South Africa: enquiries@inforegulator.org.za / +27 (0)10 023 5207</p>
          </section>

          <p className="pt-4 text-xs text-iron-500">
            Full policy: <a href="https://goodgameanvil.com/privacy" target="_blank" rel="noopener noreferrer" className="text-forge-400 hover:text-forge-300">goodgameanvil.com/privacy</a>
          </p>
        </div>
      </Card>

      <style>{`
        .prose-legal h2 { font-size: 0.875rem; font-weight: 700; color: white; text-transform: uppercase; letter-spacing: 0.05em; margin-bottom: 0.5rem; }
        .prose-legal section { border-bottom: 1px solid rgba(255,255,255,0.05); padding-bottom: 1.25rem; }
        .prose-legal section:last-of-type { border-bottom: none; }
        .prose-legal p { margin-bottom: 0.5rem; }
      `}</style>
    </div>
  );
}
